exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-tabs-item {\n  display: none;\n}\n.uu5-bricks-tabs-item-fade {\n  transition: opacity 400ms;\n}\n.uu5-bricks-tabs-item-hidden {\n  opacity: 0;\n  visibility: hidden;\n}\n.uu5-bricks-tabs-item-visible {\n  opacity: 1;\n  visibility: visible;\n}\n.tab-content > .uu5-bricks-tabs-item-hidden,\n.tab-content > .uu5-bricks-tabs-item-visible {\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/tabs-item.less
// module id = 275
// module chunks = 0